import React, { useEffect, useState } from "react";
import DropdownList from "react-widgets/DropdownList";
import axiosInstance from "Api";
import { ErrorMessage } from "formik";
import InputWrapper from "Pages/Profile/InputWrapper";
import { toast } from "react-toastify";

import { Col, FormGroup, Label, Row, Button } from "reactstrap";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Form, Formik } from "formik";
import { ReactComponent as PdfIcon } from "../../../assets/utils/images/svgs/PDF.svg";
import * as Yup from "yup";
import moment from "moment";
import useSWR from "swr";
import { useCommunityList, useDocTypes, useSaveDocument, useSaveUserDocument } from "Api/Common/CommonComponents";


const UitgifteForm = ({ type, saveDocTypeValue, docTypeName, doc, toggle, updateData, filterCommunity, currentUser, registerWithoutDocument }) => {
    const { trigger: saveDocument } = useSaveDocument();
    const { trigger: saveUserDocument } = useSaveUserDocument();
    const [formDataState, setFormDataState] = useState({
        docType: '',
        uitgifte: '',
        herinneringDatum: '',
        file: ''
    });
    const { data: docTypesResponse } = useDocTypes();

    const communityAdminId =
        type === "Gebruikers" ? currentUser?.data?.clooserId : "";

    const { data: communityResponse } = useCommunityList(communityAdminId);

    const docTypeList =
        docTypesResponse?.status === true
            ? docTypesResponse.data
            : [];

    const communityList =
        communityResponse?.status === true
            ? communityResponse.data
            : [];

    const getIntervalDate = (val) => {
        const startDate = new Date(val);
        let date = new Date(startDate);
        date.setMonth(date.getMonth() + 5);
        date.setDate(date.getDate() + 14);
        return date;
    }

    const validationSchema = Yup.object().shape({
        docType: Yup.string().required("Veld mag niet leeg zijn"),
        uitgifte: Yup.string().required("Veld mag niet leeg zijn"),

    });
    useEffect(() => {
        setFormDataState(prev => ({
            ...prev,
            docType: docTypeName,
            file: doc
        }));
    }, [docTypeName, doc]);

  const handleSubmit = (values, setSubmitting) => {
    setTimeout(() => {
        let formData = new FormData();
        formData.append(
            "saveWithoutDocument",
            registerWithoutDocument ? 1 : 0
        );

        if (!registerWithoutDocument && values.file) {
            formData.append("file", values.file);
        }

        formData.append("docType", values.docType);
        formData.append("uitgifte", values.uitgifte);

        if (type !== "Gebruikers") {
            formData.append("herinneringDatum", values.herinneringDatum);
        } else {
            formData.append("iAdminId", currentUser.data.clooserId);
            formData.append("iCommunityId", filterCommunity[0].iCommunityId);
        }

        const requestFn =
            type === "Gebruikers" ? saveUserDocument : saveDocument;

        requestFn({
            method: "post",
            data: formData,
            headers: {
                "content-type": "multipart/form-data",
            },
        })
            .then((response) => {
           
                if (
                    response?.status === true
                ) {
                    toast["success"]("Instellingen zijn bijgewerkt");
                    setFormDataState({
                        docType: "",
                        uitgifte: "",
                        herinneringDatum: "",
                        file: "",
                    });
                    toggle();
                    updateData();
                }
            })
            .catch((error) => {
                const msg =
                    error?.response?.data?.message ||
                    error?.message ||
                    "Upload mislukt";

                console.log("catch error:", error);
                toast.error(msg);
            })
            .finally(() => setSubmitting(false));
    }, 400);
};

    return (
        <>
            <Formik
                enableReinitialize
                initialValues={formDataState}
                validationSchema={validationSchema}
                onSubmit={
                    (values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
            >
                {({
                    values,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form onSubmit={handleSubmit}>
                        <div>
                            <Row>
                                <Col md="12" sm="12" lg="12">
                                    {!registerWithoutDocument && (
                                        <FormGroup row >
                                            <Label className={"setting-lebel-style text-start"}>
                                                Geselecteerd bestand
                                            </Label>
                                            <Col sm={12} className="setting-lebel-style text-start">
                                                <PdfIcon /> {doc !== '' && doc.name !== undefined ? doc.name : ''}
                                            </Col>
                                            <ErrorMessage name="file" component="small"
                                                lassName="block mt-2 invalid-feedback" />
                                        </FormGroup>
                                    )}
                                    <div className="custom-styling  mb-3">

                                        <InputWrapper label="Document type *" labelCol={3} className={'setting-lebel-style text-start'}>
                                            <DropdownList dataKey='vName' textField='vLabel'
                                                placeholder="Selecteer"
                                                className={"border rounded text-start"}
                                                onChange={(nextValue) => {
                                                    saveDocTypeValue(nextValue.iDocTypeId, nextValue.vName)
                                                    setFormDataState({ ...formDataState, docType: nextValue.vName })
                                                }}
                                                defaultValue={docTypeName}
                                                name="docType"
                                                data={docTypeList}
                                                required="true"
                                            />
                                        </InputWrapper>
                                        <ErrorMessage name="docType" component="small"
                                            className="block mt-2 invalid-feedback" />
                                    </div>

                                    <FormGroup row >
                                        <Label className={"setting-lebel-style text-start"}>
                                            Datum Uitgifte *
                                        </Label>

                                        <Col sm={12} >
                                            <div className="input-group-text input-border-styling d-flex justify-content-between">
                                                <DatePicker
                                                    locale="nl"
                                                    name="uitgifte"
                                                    dateFormat="dd-MM-yyyy"
                                                    className="me-2 border-0 bg-transparent float-start w-100"
                                                    selected={(values.uitgifte !== '' && values.uitgifte !== undefined) ? new Date(values.uitgifte) : ''}
                                                    placeholderText={'dd-mm-yyyy'}
                                                    onChange={(val) => {
                                                        setFormDataState({ ...formDataState, herinneringDatum: moment(getIntervalDate(moment(val).format('yyyy-MM-DD'))).format('yyyy-MM-DD'), uitgifte: moment(val).format('yyyy-MM-DD') })
                                                    }}
                                                />
                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                            </div>
                                            <ErrorMessage name="uitgifte" component="small"
                                                className="block mt-2 invalid-feedback" />
                                        </Col>
                                    </FormGroup>

                                    {
                                        values.uitgifte !== '' && type !== "Gebruikers" &&
                                        <FormGroup row >
                                            <Label className={"setting-lebel-style text-start"}>
                                                Datum herinnering
                                            </Label>
                                            <Col sm={12} >
                                                <div className="input-group-text input-border-styling d-flex justify-content-between">
                                                    <DatePicker
                                                        locale="nl"
                                                        name="herinneringDatum"
                                                        dateFormat="dd-MM-yyyy"
                                                        className="me-2 border-0 bg-transparent float-start w-100"
                                                        selected={(values.herinneringDatum !== '' && values.herinneringDatum !== undefined) ? new Date(values.herinneringDatum) : ''}
                                                        placeholderText={'dd-mm-yyyy'}
                                                        onChange={(val) => {
                                                            setFormDataState({ ...formDataState, herinneringDatum: moment(val).format('yyyy-MM-DD') })
                                                        }}
                                                    />
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </div>
                                                <ErrorMessage name="herinneringDatum" component="small"
                                                    className="block mt-2 invalid-feedback" />
                                            </Col>
                                        </FormGroup>
                                    }

                                </Col>
                            </Row>
                            <Button className="align-items-center btn-color-style mb-2 me-2 " size="sm" outline color="primary" type="submit" disabled={isSubmitting} >
                                Opslaan
                            </Button>
                        </div>
                    </Form>

                )}
            </Formik>

        </>
    )
}

export default UitgifteForm;
